import { render, staticRenderFns } from "./TeacherMonthlyAttendanceHistory.vue?vue&type=template&id=11aa6ae0"
import script from "../../controllers/attendance_teacher/teacher-monthly-attendance-history.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_teacher/teacher-monthly-attendance-history.js?vue&type=script&lang=js&external"
import style0 from "./TeacherMonthlyAttendanceHistory.vue?vue&type=style&index=0&id=11aa6ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports